import React, { useState, useEffect } from 'react';
import {Col, FormCheck, Row } from 'react-bootstrap';
import '../../../styles/RegDashboard.css';

export function AdminDashFilters(props) {
    const [complete, setComplete] = useState(false);
    const [incomplete, setIncomplete] = useState(false);
    const [active, setActive] = useState(true);
    const [inactive, setInactive] = useState(false);

    useEffect(() => {
        setComplete(props.complete);
        setIncomplete(props.incomplete);
        setActive(props.active);
        setInactive(props.inactive);
    },[props])

    useEffect(() => {
        props.setActive(active);
        props.setInactive(inactive);
        props.setComplete(complete);
        props.setIncomplete(incomplete);
    },[active,inactive,complete,incomplete])

    return (
        <Row>
            <Col></Col>
            <Col>
                <FormCheck
                    label={'Complete'}
                    id={"complete-check"}
                    checked={complete}
                    onChange={(e) => { setComplete(e.target.checked) }}
                />
            </Col>
            <Col>
                <FormCheck
                    label={'Incomplete'}
                    id={"incomplete-check"}
                    checked={incomplete}
                    onChange={(e) => { setIncomplete(e.target.checked) }}
                />
            </Col>
            <Col>
                <FormCheck
                    label={'Active'}
                    id={"active-check"}
                    checked={active}
                    onChange={(e) => { setActive(e.target.checked) }}
                />
            </Col>
            <Col>
                <FormCheck
                    label={'Inactive'}
                    id={"inactive-check"}
                    checked={inactive}
                    onChange={(e) => { setInactive(e.target.checked) }}
                />
            </Col>
            <Col></Col>
        </Row>
    );
}
